module.exports = "<div class=\"toaster-message\" *ngIf=\"toasterMessage.show\" [ngStyle]=\"{'background-color': bgStyle}\" [@fadeInOut]>\r\n    <a class=\"close\" (click)=\"closeModal()\"><span>&times;</span></a>\r\n    <p>{{toasterMessage.message}}</p>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/toaster/toaster.component.html
// module id = ./src/app/shared/components/toaster/toaster.component.html
// module chunks = main